import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

var amapManager = new VueAMap.AMapManager();
import border from '@/components/border/borderType'; // 人脸识别、区域告警仪表盘

import aiWarn from '@/components/env-bigData/aiWarn'; // 陌生人饼图

import aiPieAnalysis from '@/components/env-bigData/aiPieAnalysis'; // 抓拍数量曲线

import aiWarnNum from '@/components/env-bigData/aiWarnNum';
import mapTag from '@/views/dashboard/com/mapTag';
import { queryFaceList, queryMapEventList, queryAreaInfo, queryPipeSystem, queryManholeCover } from '@/api/api';
import { getAction } from '@/api/manage';
import moment from 'moment';
export default {
  computed: {
    classOption: function classOption() {
      return {
        step: .5,
        // 数值越大速度滚动越快
        limitMoveNum: 10,
        // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        // 是否开启鼠标悬停stop
        direction: 1,
        // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0,
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)

      };
    }
  },
  components: {
    aiPieAnalysis: aiPieAnalysis,
    border: border,
    aiWarn: aiWarn,
    aiWarnNum: aiWarnNum,
    mapTag: mapTag
  },
  data: function data() {
    return {
      labelState: false,
      district: null,
      citys: [],
      showChart: true,
      bigImgSrc: '',
      showImgBox: false,
      peopleList: [],
      moment: moment,
      warningType: 2,
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      mapStyle: 'amap://styles/darkblue',
      //设置地图样式
      aiWarnWidth: '',
      aiWarnHeight: '',
      aiPieAnalysisWidth: '',
      aiPieAnalysisHeight: '',
      aiWarnNumWidth: '',
      aiWarnNumHeight: '',
      selectIndex: '',
      markerList: [],
      siteDetail: {},
      netSelectindex: 0,
      roadSelectindex: 0,
      mapControlindex: 0,
      amapManager: amapManager,
      center: [118.047928, 24.613341],
      zoom: 12,
      mapSelectindex: 0,
      standardList: [],
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      Inter: null,
      pipeList: [],
      wellList: [],
      wellImg: require('@/assets/others/well.png'),
      pipeOffset: new AMap.Pixel(-20, -25)
    };
  },
  created: function created() {
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];

    if (window.localStorage.getItem('areaNameList') && window.localStorage.getItem('areaNameList') != 'null' && window.localStorage.getItem('areaNameList') != 'undefined') {
      this.citys = JSON.parse(window.localStorage.getItem('areaNameList'));
    }
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resetWidth);
    clearInterval(this.Inter);
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
      }, 1000);
    }); //自适应

    this.resetWidth();
    window.addEventListener('resize', this.resetWidth, false);
    this.initData('52');
    this.Inter = setInterval(function () {
      _this.initData('52');

      _this.showChart = false;
      var timer = setTimeout(function () {
        _this.showChart = true;
        clearTimeout(timer);
      }, 1000);
    }, 180000); // this.getPipeSystem()
    // this.getManholeCover()
  },
  methods: {
    // 获取所有管网数据
    getPipeSystem: function getPipeSystem() {
      var that = this;
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(function (item) {
            var pointList = item.coordinate.split(':');
            var lines = pointList.map(function (v) {
              return v.split('-').map(function (item) {
                return item.split(',');
              });
            });
            item.lines = lines;
            return item;
          });
        }
      });
    },
    // 获取所有窨井盖数据
    getManholeCover: function getManholeCover() {
      var _this2 = this;

      var that = this;
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.wellList = res.result.records.map(function (item) {
            return {
              id: item.id,
              position: item.coordinate.split(','),
              content: "<img style=\"width: 30px;height: 30px;\" src=\"".concat(_this2.wellImg, "\" />"),
              events: function events() {// 点击窨井盖
              }
            };
          });
        }
      });
    },
    onToChangeLabel: function onToChangeLabel() {
      this.labelState = !this.labelState;
      console.log('this.labelState', this.labelState);
      this.initMarker();
    },
    initMarker: function initMarker() {
      var _this3 = this;

      console.log('markerList', this.markerList);
      this.markerList.forEach(function (item) {
        if (_this3.labelState) {
          item['label'] = {
            content: item.name,
            offset: [0, -20]
          };
        } else {
          item['label'] = {
            content: '',
            offset: [0, 0]
          };
        }
      });
    },
    drawBounds: function drawBounds(type) {
      var map = amapManager.getMap();
      var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
      areaRoot.forEach(function (item) {
        queryAreaInfo(item).then(function (res) {
          if (res.success) {
            var features = [];

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
              var inline = features.map(function (area) {
                return area.map(function (info) {
                  return new AMap.LngLat(info[0], info[1], true);
                });
              });
              var pathArray = [outer];
              pathArray.push.apply(pathArray, inline);
              var polygon = new AMap.Polygon({
                // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                pathL: pathArray,
                //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                strokeColor: 'rgb(20,164,173)',
                strokeWeight: 4,
                //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                strokeOpacity: 0.5,
                //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                fillColor: type == 1 ? 'rgba(0,0,0)' : 'rgba(99,99,99)',
                //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                fillOpacity: type == 1 ? 0.5 : 0.3,
                zIndex: 99999999
              });
              polygon.setPath(pathArray);
              map.add(polygon); // features.forEach(area=>{
              //   var polygon = new AMap.Polygon({
              //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //     path: area,
              //     strokeColor: "#FF33FF",
              //     strokeWeight: 3,
              //     strokeOpacity: 0.5,
              //     fillOpacity: 0.3,
              //     fillColor: "#1791fc",
              //     zIndex: 99999999,
              //   });
              //   map.add(polygon);
              // })
            }
          }
        });
      });
    },
    showImg: function showImg(item) {
      // 区域告警
      if (item.eventType) {
        this.showImgBox = true;
        this.bigImgSrc = this.getImageView(item.srcId);
      }
    },
    handleCancel: function handleCancel() {
      this.showImgBox = false;
    },
    onWindowChange: function onWindowChange(e) {
      if (e) {
        this.markerList.forEach(function (item) {
          item.showWindow = true;
        });
      } else {
        this.markerList.forEach(function (item) {
          item.showWindow = false;
        });
      }
    },
    getPeopleList: function getPeopleList() {
      var _this4 = this;

      queryFaceList().then(function (res) {
        if (res.success) {
          _this4.peopleList = res.result;
        }
      });
    },
    warningChangeRadio: function warningChangeRadio(e) {
      this.warningType = e.target.value;
    },
    // 获取对应点击的站点的站点详情
    getsiteDetail: function getsiteDetail(id) {
      var _this5 = this;

      queryBigDataById({
        id: id
      }).then(function (res) {
        if (res.success) {
          res.result.photo = _this5.getImageView(res.result.photo);
          _this5.siteDetail = res.result;
        }
      });
    },
    changeMap: function changeMap() {
      var _this6 = this;

      if (this.plugin[0].defaultType) this.plugin[0].defaultType = 0;else this.plugin[0].defaultType = 1;
      this.mapControlindex = 1;
      this.$nextTick(function () {
        _this6.mapControlindex = 0;
        _this6.zoom = 15;
        setTimeout(function () {
          _this6.drawBounds(_this6.plugin[0].defaultType);
        }, 500);

        _this6.$nextTick(function () {
          // setTimeout(() => {
          _this6.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12; // }, 500)
        }); // this.changeVisible()

      });
    },
    // 点击详情中的查看详情跳转
    ontoSite: function ontoSite() {
      var _this7 = this;

      sessionStorage.setItem('selectId', JSON.stringify(this.siteDetail));
      setTimeout(function () {
        _this7.$emit('siteTurn', true);
      }, 100);
    },
    // 重新渲染地图上的站点
    changeVisible: function changeVisible() {
      var _this8 = this;

      var arr = [];
      var that = this;
      that.markerList.forEach(function (item, index) {
        var position;
        if (item.longitude != 'NaN') position = [item.longitude, item.latitude];else position = _this8.center;
        item.position = position;
        item.show = true;

        if (item.dateStr) {
          item.zIndex = 1000000;
        } else {
          item.zIndex = 1;
        }

        item.icon = 'icon-yiliaofeishui';
        item.color = '#ccc';

        if (index < 5) {
          if (item.dateStr) {
            item.showWindow = true;
            item.nodata = false;
            item.color = 'red';
          } else {
            item.nodata = true;
          }
        } else {
          if (item.dateStr) {
            item.showWindow = false;
            item.nodata = false;
            item.color = 'red';
          } else {
            item.nodata = true;
          }
        }

        var positions;
        if (item.longitude != 'NaN') positions = [item.longitude, item.latitude];else positions = that.center;
      });
    },
    // 点击路况
    onselectRoad: function onselectRoad() {
      var _this9 = this;

      this.roadSelectindex = !this.roadSelectindex; // this.$forceUpdate()
      // let a = this.$refs.maps.$$getInstance()

      if (this.plugin[0].showTraffic) this.plugin[0].showTraffic = false;else this.plugin[0].showTraffic = true;
      this.mapControlindex = 1;
      this.zoom = 15;
      this.$nextTick(function () {
        // this.changeVisible()
        _this9.mapControlindex = 0;
        setTimeout(function () {
          _this9.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
        }, 1000);
      });
    },
    // 点击路网
    onselectNet: function onselectNet() {
      var _this10 = this;

      this.netSelectindex = !this.netSelectindex;
      if (this.plugin[0].showRoad) this.plugin[0].showRoad = false;else this.plugin[0].showRoad = true;
      this.mapControlindex = 1;
      this.zoom = 15;
      this.$nextTick(function () {
        // this.changeVisible()
        _this10.mapControlindex = 0;
        setTimeout(function () {
          _this10.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
        }, 1000);
      });
    },
    // 点击卫星
    onselectMap: function onselectMap(index) {
      this.mapSelectindex = !this.mapSelectindex;
      this.changeMap();
    },
    // 获取各个站点数据
    getSite: function getSite(st) {
      var _this11 = this;

      var that = this;
      var param = st ? {
        st: st
      } : {};
      queryMapEventList(param).then(function (res) {
        if (res.success) {
          var arr = [];
          that.onlineNum = 0;
          res.result.forEach(function (item, index) {
            if (item.onlineStatus) {
              that.onlineNum++;
            }

            if (item.longitude != 'NaN') item.position = [item.longitude, item.latitude];else item.position = ['118.04792', '24.61334'];
            item.show = true;
            item.title = item.name;

            if (_this11.labelState) {
              item['label'] = {
                content: item.name,
                offset: [0, -20]
              };
            } else {
              item['label'] = {
                content: '',
                offset: [0, 0]
              };
            }

            item.offset = [0, -3];

            if (item.dateStr) {
              item.zIndex = 1000000;
            } else {
              item.zIndex = 1;
            }

            item.icon = 'icon-yiliaofeishui';
            item.color = '#ccc';

            if (index < 5) {
              if (item.dateStr) {
                item.showWindow = true;
                item.nodata = false;
                item.color = 'red';

                if (index == 0) {
                  // 最新一条数据的坐标为中心点
                  _this11.center = [item.longitude, item.latitude];
                }
              } else {
                item.nodata = true;
              }
            } else {
              if (item.dateStr) {
                item.showWindow = false;
                item.nodata = false;
                item.color = 'red';
              } else {
                item.nodata = true;
              }
            }

            var positions;
            if (item.longitude != 'NaN') positions = [item.longitude, item.latitude];else positions = that.center;
          });
          _this11.markerList = res.result;
        }
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    // 自适应
    resetWidth: function resetWidth() {
      this.$refs.columnBorder.width = document.documentElement.clientWidth * 0.23;
      this.$refs.columnBorder.height = document.documentElement.clientHeight * 0.88;
      this.$refs.warnBorder1.width = document.documentElement.clientWidth * 0.23;
      this.$refs.warnBorder1.height = document.documentElement.clientHeight * 0.277;
      this.$refs.warnBorder2.width = document.documentElement.clientWidth * 0.23;
      this.$refs.warnBorder2.height = document.documentElement.clientHeight * 0.277;
      this.$refs.warnBorder3.width = document.documentElement.clientWidth * 0.23;
      this.$refs.warnBorder3.height = document.documentElement.clientHeight * 0.277;
      this.aiWarnWidth = document.documentElement.clientWidth * 0.23 + 'px';
      this.aiWarnHeight = document.documentElement.clientHeight * 0.27 + 'px';
      this.aiPieAnalysisWidth = document.documentElement.clientWidth * 0.23 + 'px';
      this.aiPieAnalysisHeight = document.documentElement.clientHeight * 0.27 + 'px';
      this.aiWarnNumWidth = document.documentElement.clientWidth * 0.23 + 'px';
      this.aiWarnNumHeight = document.documentElement.clientHeight * 0.27 + 'px';
    },
    initData: function initData(st) {
      var _this12 = this;

      this.showState = false;
      this.$nextTick(function () {
        _this12.showState = true;
        setTimeout(function () {
          _this12.getSite(st);

          _this12.getPeopleList();

          _this12.drawBounds();
        }, 500);
      });
    },
    selctTag: function selctTag(index, id) {
      //  if(this.standardList[index].data.show){
      if (index == this.standardList.length) {
        this.markerList.forEach(function (item, index) {
          if (!item.currentStandard) {
            item.show = !item.show;
          }
        });
      } else {
        this.standardList[index].data.show = !this.standardList[index].data.show;
        this.markerList.forEach(function (item, index) {
          if (item.currentStandard) {
            if (item.currentStandard.id == id) {
              item.show = !item.show;
            }
          }
        });
      } //  }

    }
  }
};